import {
  wellLifeContractTypeOptions,
  wellLifeCypContractTypeOptions,
  owlCentreContractTypeOptions,
  subContractTypeOptions,
  SUBCONTRACT_OPTIONS_BY_CONTRACT,
  adultAdhdCollectsNationalRtcSubcontract,
} from '../../../../constants/assessmentTypesByOrg';

// Define the base/default configuration
const defaultConfig = {
    steps: {
      '1': {
        title: "Patient Information",
        fields: {
          '1': {
            varName: "title",
            displayText: "Title",
            inputType: "selectOneDropdown",
            options: [
              { value: "Mr.", label: "Mr." },
              { value: "Mrs.", label: "Mrs." },
              { value: "Ms.", label: "Ms." },
              { value: "Miss", label: "Miss" },
              { value: "Dr.", label: "Dr." },
              { value: "Other", label: "Other / Prefer not to say" }, // if other, don't prefill and let patient choose
            ],
            isCustomField: true,
            required: true,            
          },
          '2': {
            varName: "firstName",
            displayText: "First Name",
            inputType: "freeText",
            placeholder: "Enter first name",
            required: true,
          },
          '3': {
            varName: "lastName",
            displayText: "Last Name",
            inputType: "freeText",
            placeholder: "Enter last name",
            required: true,
          },
          '4': {
            varName: "email",
            displayText: "Email Address",
            inputType: "freeText",
            placeholder: "Enter email address",
            required: true,
          },          
        }
      },
     '2': {
      title: "Assign Users to Patient",
      fields: {
        '1': {
          varName: "leadClinician",
          displayText: "Lead Clinician",
          inputType: "selectOneDropdown",
          placeholder: "Select the lead clinician",
        //   description: "The clinician primarily responsible for this patient",
          required: true,
        },
        '2': {
          varName: "supportClinicians",
          displayText: "Additional Clinician(s)",
          inputType: "selectMultipleDropdown",
          placeholder: "Select additional clinician(s)",
        //   description: "Other clinicians who will work with this patient",
          required: false,
        },
      }
    },
      '3': {
      title: "Assign Clinicians to Assessment Stages",
      fields: {
        '1': {
          varName: "clinicianCI",
          displayText: "Clinical Interview",
          inputType: "selectOneButtons",
        //   description: "Select the clinician responsible for conducting the Clinical Interview",
          required: true,
        },
        '2': {
          varName: "clinicianSSI",
          displayText: "Semi-Structured Interview",
          inputType: "selectOneButtons",
        //   description: "Select the clinician responsible for conducting the Semi-Structured Interview",
          required: true,
        },
        '3': {
          varName: "clinicianDD",
          displayText: "Diagnostic Decision",
          inputType: "selectMultipleButtons", // e.g. MDT review
        //   description: "Select the clinicians involved in making the Diagnostic Decision",
          required: true,
          // minSelections declares how many clinicians must be chosen for this
          // MDT-review field. The default (used by orgs on defaultConfig, e.g.
          // "ADHD and Autism Associates") requires 2 (lead + one MDT reviewer).
          // Orgs that defer the supporting/MDT clinician to after setup (see
          // Well Life Clinic) override this to 1 so the lead alone is valid.
          minSelections: 2,
        },
        '4': {
          varName: "clinicianPAD",
          displayText: "Post-Assessment Discussion",
          inputType: "selectOneButtons",
        //   description: "Select the clinician responsible for the Post-Assessment Discussion",
          required: true,
        }
      }
    }, 
    '4': {
        title: "Reference Number",
        fields: {
          '1': {
            varName: "referenceNumber",
            displayText: "Patient Reference Number",
            inputType: "freeText",
            placeholder: "Enter Patient Reference Number",
            required: true,
            isCustomField: true,
          }
        }
      }, 
    '5': {
        title: "Patient Type",
        fields: {
          '1': {
            varName: "demoOrTest",
            displayText: "Patient Type",
            inputType: "selectOneDropdown",
            options: [
              { value: "Blank Patient", label: "Blank Patient" },

              { value: "Demo 1 (Male)", label: "Demo 1 (Male)" },
              { value: "Demo 2 (Female)", label: "Demo 2 (Female)" },

              { value: "Training Scenario 1 (Jane Smith)", label: "Training Scenario 1 (Jane Smith)" },
              { value: "Training Scenario 2 (John Smith)", label: "Training Scenario 2 (John Smith)" },
              { value: "Training Scenario 3 (Jane Doe)", label: "Training Scenario 3 (Jane Doe)" },
              { value: "Training Scenario 4 (John Doe)", label: "Training Scenario 4 (John Doe)" },
              { value: "Training Scenario 5 (John Smith - No SSI)", label: "Training Scenario 5 (John Smith - No SSI)" }, 
            ],
            required: false,
            isCustomField: true,
          }
        }
      }   
    }
  };

// ThinkDivergent specific configuration
const TDServiceConfig = {
  steps: {
    '1': {
      title: "Patient Information",
      fields: {        
        '1': {
          varName: "firstName",
          displayText: "First Name",
          inputType: "freeText",
          placeholder: "Enter first name",
          required: true,
        },
        '2': {
          varName: "lastName",
          displayText: "Last Name",
          inputType: "freeText",
          placeholder: "Enter last name",
          required: true,
        },
        '3': {
          varName: "email",
          displayText: "Email Address",
          inputType: "freeText",
          placeholder: "Enter email address",
          required: true,
        },          
      }
    },
   '2': {
      title: "Assign Users to Patient",
      fields: {
        '1': {
          varName: "leadClinician",
          displayText: "Lead Clinician",
          inputType: "selectOneDropdown",
          placeholder: "Select the lead clinician",
        //   description: "The clinician primarily responsible for this patient",
          required: true,
        },
        '2': {
          varName: "supportClinicians",
          displayText: "Additional Clinician(s)",
          inputType: "selectMultipleDropdown",
          placeholder: "Select additional clinician(s)",
        //   description: "Other clinicians who will work with this patient",
          required: false,
        },
      }
    },
      '3': {
      title: "Assign Clinicians to Assessment Stages",
      fields: {
        '1': {
          varName: "clinicianCI",
          displayText: "Clinical Interview",
          inputType: "selectOneButtons",
        //   description: "Select the clinician responsible for conducting the Clinical Interview",
          required: true,
        },
        '2': {
          varName: "clinicianSSI",
          displayText: "Semi-Structured Interview",
          inputType: "selectOneButtons",
        //   description: "Select the clinician responsible for conducting the Semi-Structured Interview",
          required: true,
        },
        '3': {
          varName: "clinicianDD",
          displayText: "Diagnostic Decision",
          inputType: "selectOneButtons",
        //   description: "Select the clinicians involved in making the Diagnostic Decision",
          required: true,
        },
        '4': {
          varName: "clinicianPAD",
          displayText: "Post-Assessment Discussion",
          inputType: "selectOneButtons",
        //   description: "Select the clinician responsible for the Post-Assessment Discussion",
          required: true,
        }
      }
    }, 
  '4': {
      title: "Reference Number",
      fields: {
        '1': {
          varName: "referenceNumber",
          displayText: "Patient Reference Number",
          inputType: "freeText",
          placeholder: "Enter Patient Reference Number",
          required: true,
          isCustomField: true,
        }
      }
    }, 
  }
};

// Phoenix Mental Health Services specific configuration
const phoenixConfig = {
    steps: {
        // Steps 1 and 2 are the same as default
        '1': JSON.parse(JSON.stringify(defaultConfig.steps['1'])),
        '2': JSON.parse(JSON.stringify(defaultConfig.steps['2'])),
        
        // Step 3 with the modified field
        '3': {
          ...JSON.parse(JSON.stringify(defaultConfig.steps['3'])),
          title: "Assign Clinicians to Assessment Stages",
          fields: {
            ...JSON.parse(JSON.stringify(defaultConfig.steps['3'].fields)),
            // Override the specific field directly
            '3': {
                varName: "clinicianDD",
                displayText: "Diagnostic Decision",
                inputType: "selectOneButtons", 
                required: true,
            },
            '4': {
              varName: "clinicianPAD",
              displayText: "Medication Appointment",
              inputType: "selectOneButtons",
            //   description: "Select the clinician responsible for the Medication Appointment",
              required: true,
            }
          }
        },    
        '4': {
        title: "Patient's Home Address",
        fields: {
          '1': {
            varName: "streetAddress",
            displayText: "Street Address",
            inputType: "freeText",
            placeholder: "Enter their street address",
            required: false,
            isCustomField: true,
          },
          '2': {
            varName: "city",
            displayText: "City",
            inputType: "freeText",
            placeholder: "Enter their city",
            required: false,
            isCustomField: true,
          },
          '3': {
            varName: "postcode",
            displayText: "Postcode",
            inputType: "freeText",
            placeholder: "Enter their postcode",
            required: false,
            isCustomField: true,
          },
        }
      },     
      '5': {
        title: "GP Information",
        fields: {
          '1': {
            varName: "gpName",
            displayText: "GP Name",
            inputType: "freeText",
            placeholder: "Enter GP name",
            required: false,
            isCustomField: true,
          },
          '2': {
            varName: "gpSurgery",
            displayText: "GP Surgery / Practice",
            inputType: "freeText",
            placeholder: "Enter GP surgery or practice name",
            required: false,
            isCustomField: true,
          },
          '3': {
            varName: "gpAddress",
            displayText: "GP Address",
            inputType: "freeText",
            placeholder: "Enter GP address",
            required: false,
            isCustomField: true,
          },
        }
      },
      '6': {
        title: "Bupa Policy Number (if applicable)",
        fields: {         
          '1': {
            varName: "bupaPolicyNumber",
            displayText: "Bupa Policy Number",
            description: "Enter the Bupa policy number if the patient is insured with Bupa. Leave blank if patient is Self-Funded.",
            inputType: "freeText",
            placeholder: "Enter Bupa policy number",
            required: false,            
            isCustomField: true,
          },       
        }
      },
      '7': {
        title: "Patient Type",
        fields: {
          '1': {
            varName: "demoOrTest",
            displayText: "Patient Type",
            inputType: "selectOneDropdown",
            options: [
              { value: "Blank Patient", label: "Blank Patient" },

              { value: "Demo 1 (Male)", label: "Demo 1 (Male)" },
              { value: "Demo 2 (Female)", label: "Demo 2 (Female)" },

              { value: "Training Scenario 1 (Jane Smith)", label: "Training Scenario 1 (Jane Smith)" },
              { value: "Training Scenario 2 (John Smith)", label: "Training Scenario 2 (John Smith)" },
              { value: "Training Scenario 3 (Jane Doe)", label: "Training Scenario 3 (Jane Doe)" },
              { value: "Training Scenario 4 (John Doe)", label: "Training Scenario 4 (John Doe)" },
              { value: "Training Scenario 5 (John Smith - No SSI)", label: "Training Scenario 5 (John Smith - No SSI)" },
            ],
            required: false,
            isCustomField: true,
          }
        }
      }  
    }
  };

// SLaM full configuration (retained for reference — previously used when SLaM
// assigned clinicians at setup time). The active SLaM config is slamDeferredConfig
// below, which omits the clinician assignment steps so they can be done retroactively.
const slamFullConfig = {
  steps: {
      // Steps 1 and 2 are the same as default
      '1': JSON.parse(JSON.stringify(defaultConfig.steps['1'])),
      '2': JSON.parse(JSON.stringify(defaultConfig.steps['2'])),
      
      // Step 3 with the modified field
      '3': {
        ...JSON.parse(JSON.stringify(defaultConfig.steps['3'])),
        title: "Assign Clinicians to Assessment Stages",
        fields: {
          // Re-ordered for SLaM: SSI before CI
          '1': {
            varName: "clinicianSSI",
            displayText: "Semi-Structured Interview",
            inputType: "selectOneButtons",
            required: true,
          },
          '2': {
            varName: "clinicianCI",
            displayText: "Clinical Interview",
            inputType: "selectOneButtons",
            required: true,
          },
          '3': {
            varName: "clinicianDD",
            displayText: "Diagnostic Decision",
            inputType: "selectOneButtons",
            required: true,
          },
          '4': {
            varName: "clinicianPAD",
            displayText: "Post-Assessment Discussion",
            inputType: "selectOneButtons",
            required: true,
          },
        }
      },
      '4': {
        title: "Trust ID",
        fields: {
          '1': {
            varName: "referenceNumber",
            displayText: "Trust ID",
            inputType: "freeText",
            placeholder: "Enter Trust ID",
            required: true,
            isCustomField: true,
          }
        }
      }, 
      '5': {
        title: "NHS number",
        fields: {
          '1': {
            varName: "nhsNumber",
            displayText: "NHS Number",
            inputType: "freeText",
            placeholder: "Enter NHS Number",
            required: false,
            isCustomField: true,
          }
        }
      },
      '6': {
        title: "Patient's Home Address",
        fields: {
          '1': {
            varName: "streetAddress",
            displayText: "Street Address",
            inputType: "freeText",
            placeholder: "Enter their street address",
            required: false,
            isCustomField: true,
          },
          '2': {
            varName: "city",
            displayText: "City",
            inputType: "freeText",
            placeholder: "Enter their city",
            required: false,
            isCustomField: true,
          },
          '3': {
            varName: "postcode",
            displayText: "Postcode",
            inputType: "freeText",
            placeholder: "Enter their postcode",
            required: false,
            isCustomField: true,
          },
        }
      }, 
    '7': {
      title: "GP Information",
      fields: {
        '1': {
          varName: "gpName",
          displayText: "GP Name",
          inputType: "freeText",
          placeholder: "Enter GP name",
          required: false,
          isCustomField: true,
        },
        '2': {
          varName: "gpSurgery",
          displayText: "GP Surgery / Practice",
          inputType: "freeText",
          placeholder: "Enter GP surgery or practice name",
          required: false,
          isCustomField: true,
        },
        '3': {
          varName: "gpAddress",
          displayText: "GP Address",
          inputType: "freeText",
          placeholder: "Enter GP address",
          required: false,
          isCustomField: true,
        },
      }
    }, 
    '8': {
        title: "Patient's Gender Identity",
        fields: {
          '1': {
            varName: "genderIdentity",
            displayText: "Gender Identity",
            inputType: "selectOneDropdown",
            options: [
              { value: "Male", label: "Male" },
              { value: "Female", label: "Female" },
              { value: "Other", label: "Other" }, // if Other, don't prefill and let patient choose
            ],
            required: false,
            isCustomField: true,
          },
          // SLAM-specific ethnicity with granular options for reporting
          // Note: Backend prefill should SKIP when value is "Not stated" or "Other ethnic group - Other"
          '2': {
            varName: "ethnicity",
            displayText: "Ethnicity",
            inputType: "selectOneDropdown",
            options: [
              { value: "Asian/Asian British - Bangladeshi", label: "Asian/Asian British - Bangladeshi" },
              { value: "Asian/Asian British - Chinese", label: "Asian/Asian British - Chinese" },
              { value: "Asian/Asian British - Indian", label: "Asian/Asian British - Indian" },
              { value: "Asian/Asian British - Pakistani", label: "Asian/Asian British - Pakistani" },
              { value: "Asian/Asian British - Other", label: "Asian/Asian British - Other" },
              { value: "Black/Black British - African", label: "Black/Black British - African" },
              { value: "Black/Black British - Caribbean", label: "Black/Black British - Caribbean" },
              { value: "Black/Black British - Other", label: "Black/Black British - Other" },
              { value: "Mixed Race/Mixed Race British - White and Asian", label: "Mixed Race/Mixed Race British - White and Asian" },
              { value: "Mixed Race/Mixed Race British - White and Black African", label: "Mixed Race/Mixed Race British - White and Black African" },
              { value: "Mixed Race/Mixed Race British - White and Black Caribbean", label: "Mixed Race/Mixed Race British - White and Black Caribbean" },
              { value: "Mixed Race/Mixed Race British - Other Mixed Race Background", label: "Mixed Race/Mixed Race British - Other Mixed Race Background" },
              { value: "White - British", label: "White - British" },
              { value: "White - Gypsy or Irish Traveller", label: "White - Gypsy or Irish Traveller" },
              { value: "White - Irish", label: "White - Irish" },
              { value: "White - Other", label: "White - Other" },
              { value: "Other ethnic group - Arab", label: "Other ethnic group - Arab" },
              { value: "Other ethnic group - Other", label: "Other ethnic group - Other" }, // backend will not prefill this
              { value: "Not stated", label: "Not stated" }, // backend will not prefill this
            ],
            required: false,
            isCustomField: true,
          },
        }
      }, 
    '9': {
        title: "Interpreter Need",
        fields: {
          '1': {
            varName: "interpreterRequired",
            displayText: "Interpreter Required?",
            inputType: "selectOneDropdown",
            options: [
              { value: "Yes", label: "Yes" },
              { value: "No", label: "No" },
            ],
            required: true,
            isCustomField: true,
          }
        }
      },   
    '10': {
      title: "Patient Type",
      fields: {
        '1': {
          varName: "demoOrTest",
          displayText: "Patient Type",
          inputType: "selectOneDropdown",
          options: [
            { value: "Blank Patient", label: "Blank Patient" },

            { value: "Demo 1 (Male)", label: "Demo 1 (Male)" },
            { value: "Demo 2 (Female)", label: "Demo 2 (Female)" },

            { value: "Training Scenario 1 (Jane Smith)", label: "Training Scenario 1 (Jane Smith)" },
            { value: "Training Scenario 2 (John Smith)", label: "Training Scenario 2 (John Smith)" },
            { value: "Training Scenario 3 (Jane Doe)", label: "Training Scenario 3 (Jane Doe)" },
            { value: "Training Scenario 4 (John Doe)", label: "Training Scenario 4 (John Doe)" },
            { value: "Training Scenario 5 (John Smith - No SSI)", label: "Training Scenario 5 (John Smith - No SSI)" },
          ],
          required: false,
          isCustomField: true,
        }
      }
    }  
  }
};

// SLaM deferred clinician assignment configuration
//
// Same patient metadata steps as the full SLaM config (Trust ID, NHS Number,
// address, GP, gender/ethnicity, interpreter, patient type) but WITHOUT the
// clinician assignment steps (steps 2 and 3 in the full config). Clinicians
// are assigned after patient creation, and the shape of that assignment
// depends on the patient's stamped workflow (see AssignCliniciansDialog):
//
//   Legacy two-clinician, SSI-first patients (stamped before Oct 2026):
//     1. SSI clinician assigned first (for the initial SSI appointment)
//     2. Lead clinician assigned later (maps to Lead + CI + DD + PAD)
//
//   One-clinician, CI-first patients (the current SLaM preset):
//     1. A single Lead clinician assigned once (Lead + CI + SSI + DD + PAD),
//        who runs the whole assessment in one appointment.
//
// Both generations therefore still start life with no clinicians, which is
// why this deferred config is kept rather than reinstating setup-time
// assignment steps.
//
// The existing reassignClinicians backend endpoint handles the SSI-only and
// both Lead-bundle shapes via per-stage primary assignments — no new backend
// endpoint is needed.
const slamDeferredConfig = {
  steps: {
    '1': JSON.parse(JSON.stringify(slamFullConfig.steps['1'])),
    '2': JSON.parse(JSON.stringify(slamFullConfig.steps['4'])),
    '3': JSON.parse(JSON.stringify(slamFullConfig.steps['5'])),
    '4': JSON.parse(JSON.stringify(slamFullConfig.steps['6'])),
    '5': JSON.parse(JSON.stringify(slamFullConfig.steps['7'])),
    '6': JSON.parse(JSON.stringify(slamFullConfig.steps['8'])),
    '7': JSON.parse(JSON.stringify(slamFullConfig.steps['9'])),
    '8': JSON.parse(JSON.stringify(slamFullConfig.steps['10'])),
  }
};

// Urban ADHD deferred clinician assignment configuration
//
// Urban ADHD is a PRIVATE provider that runs the SLaM two-clinician, SSI-first
// clinical workflow (see 'Urban ADHD' in src/constants/workflowConfig.js), so
// it needs the same deferred clinician assignment pattern as SLaM:
//   1. SSI clinician assigned first (for the initial SSI appointment)
//   2. Lead clinician assigned later (maps to Lead + CI + DD + PAD)
// That two-step assignment UX is switched on by listing the org in
// SLAM_ORG_NAMES below (isSlamOrg) — no clinician steps appear at setup.
//
// Unlike slamDeferredConfig, this omits the NHS-only identifiers (Trust ID,
// NHS Number, granular ethnicity, interpreter need) and the home address / GP
// steps, which a private clinic does not collect at referral. What remains is
// the default org's patient metadata minus the two clinician-assignment steps:
//   defaultConfig step 1 → Patient Information (title, name, email)
//   defaultConfig step 4 → Patient Reference Number
//   defaultConfig step 5 → Patient Type (demo / training presets)
// Steps are re-numbered contiguously because PatientSetupForm walks step keys
// in order to drive the wizard.
const urbanAdhdDeferredConfig = {
  steps: {
    '1': JSON.parse(JSON.stringify(defaultConfig.steps['1'])),
    '2': JSON.parse(JSON.stringify(defaultConfig.steps['4'])),
    '3': JSON.parse(JSON.stringify(defaultConfig.steps['5'])),
  }
};

// Well Life Clinic full configuration (retained for reference -- previously
// used when WLC assigned clinicians at setup time). The active WLC config is
// wellLifeDeferredConfig below, which omits the clinician assignment steps
// so they can be done retroactively via the Patient Overview page.
const wellLifeFullConfig = {
    steps: {        
        '1': {
        title: "Patient Information",
        fields: {
          '1': {
            varName: "title",
            displayText: "Title",
            inputType: "selectOneDropdown",
            options: [
              { value: "Mr.", label: "Mr." },
              { value: "Mrs.", label: "Mrs." },
              { value: "Ms.", label: "Ms." },
              { value: "Miss", label: "Miss" },
              { value: "Dr.", label: "Dr." },
              { value: "Other", label: "Other / Prefer not to say" }, // if other, don't prefill and let patient choose
            ],
            isCustomField: true,
            required: true,            
          },
          '2': {
            varName: "firstName",
            displayText: "First Name",
            inputType: "freeText",
            placeholder: "Enter first name",
            required: true,
          },
          '3': {
            varName: "lastName",
            displayText: "Last Name",
            inputType: "freeText",
            placeholder: "Enter last name",
            required: true,
          },
          '4': {
            varName: "email",
            displayText: "Email Address",
            inputType: "freeText",
            placeholder: "Enter email address",
            required: true,
          },          
        }
      },

        '2': {
      title: "Assign Users to Patient",
      fields: {
        '1': {
          varName: "leadClinician",
          displayText: "Lead Clinician",
          inputType: "selectOneDropdown",
          placeholder: "Select the lead clinician",
        //   description: "The clinician primarily responsible for this patient",
          required: true,
        },
        '2': {
          varName: "supportClinicians",
          displayText: "Additional Clinician(s)",
          inputType: "selectMultipleDropdown",
          placeholder: "Select additional clinician(s)",
        //   description: "Other clinicians who will work with this patient",
          // Optional at setup: WLC always assigns a lead (mapped to CI/SSI/DD/PAD)
          // but may not yet know which clinician will support the DD / MDT review.
          // The supporting/MDT clinician can be added later from the patient
          // overview (DD card "+" or the "Reassign Clinicians" action).
          required: false,
        },        
      }
    },
        // Step 3 with the modified field
        '3': {
          ...JSON.parse(JSON.stringify(defaultConfig.steps['3'])),
          title: "Assign Clinicians to Assessment Stages",
          fields: {
            ...JSON.parse(JSON.stringify(defaultConfig.steps['3'].fields)),
            // Override the specific field directly
            '3': {
              varName: "clinicianDD",
              displayText: "Diagnosis Decision (MDT Review)",
              inputType: "selectMultipleButtons", // e.g. MDT review
            //   description: "Select the clinicians involved in the MDT Review",
              required: true,
              // Lead only is valid at setup (minSelections: 1); the MDT reviewer
              // is optional here and can be added later. Overrides defaultConfig's
              // minSelections: 2. The UI still caps selection at 2 (lead + one MDT).
              minSelections: 1,
            },
            '4': {
              varName: "clinicianPAD",
              displayText: "Post-Assessment Discussion",
              inputType: "selectOneButtons",
            //   description: "Select the clinician responsible for the Feedback Appointment",
              required: true,
            }
          }
        },
      '4': {
        title: "Patient's Home Address",
        fields: {
          '1': {
            varName: "streetAddress",
            displayText: "Street Address",
            inputType: "freeText",
            placeholder: "Enter their street address",
            required: false,
            isCustomField: true,
          },
          '2': {
            varName: "city",
            displayText: "City",
            inputType: "freeText",
            placeholder: "Enter their city",
            required: false,
            isCustomField: true,
          },
          '3': {
            varName: "postcode",
            displayText: "Postcode",
            inputType: "freeText",
            placeholder: "Enter their postcode",
            required: false,
            isCustomField: true,
          },
        }
      },  
      '5': {
        title: "Patient's Gender Identity",
        fields: {
          '1': {
            varName: "genderIdentity",
            displayText: "Gender Identity",
            inputType: "selectOneDropdown",
            options: [
              { value: "Male", label: "Male" },
              { value: "Female", label: "Female" },
              { value: "Non-binary", label: "Non-binary" },
              { value: "Unspecified", label: "Unspecified" }, // if unspecified, don't prefill and let patient choose
            ],
            required: false,
            isCustomField: true,
          },
        }
      }, 
      '6': {
        title: "Patient's Date of Birth",
        fields: {
          '1': {
            varName: "dateOfBirth",
            displayText: "Date of Birth",
            inputType: "date",            
            required: false,
            isCustomField: true,
          },
        }
      },
      '7': {
        title: "Reference Number",
        fields: {
          '1': {
            varName: "referenceNumber",
            displayText: "Semble Reference Number",
            inputType: "freeText",
            placeholder: "Enter Semble Reference Number",
            required: true,
            isCustomField: true,
          }
        }
      },
      '8': {
        // TOC/WLC terminology: "Contract Type" is the client-facing label for what the backend
        // stores as assessmentType. The varName remains unchanged so all downstream logic,
        // filters, and Firestore documents continue to work without migration.
        title: "Contract Type",
        fields: {
          '1': {
            varName: "assessmentType",
            displayText: "Contract Type",
            inputType: "selectOneDropdown",
            // Shared list (includes NHS - Kent). MDT Org reuses the WLC
            // deferred config so create/edit also gets these options; MDT is
            // not in the analytics/dashboard filter map by design.
            options: wellLifeContractTypeOptions(),
            required: true,
            isCustomField: true,
          }
        }
      },
      '9': {
        title: "Patient Type",
        fields: {
          '1': {
            varName: "demoOrTest",
            displayText: "Patient Type",
            inputType: "selectOneDropdown",
            options: [
              { value: "Blank Patient", label: "Blank Patient" },

              { value: "Demo 1 (Male)", label: "Demo 1 (Male)" },
              { value: "Demo 2 (Female)", label: "Demo 2 (Female)" },

              { value: "Training Scenario 1 (Jane Smith)", label: "Training Scenario 1 (Jane Smith)" },
              { value: "Training Scenario 2 (John Smith)", label: "Training Scenario 2 (John Smith)" },
              { value: "Training Scenario 3 (Jane Doe)", label: "Training Scenario 3 (Jane Doe)" },
              { value: "Training Scenario 4 (John Doe)", label: "Training Scenario 4 (John Doe)" },
              { value: "Training Scenario 5 (John Smith - No SSI)", label: "Training Scenario 5 (John Smith - No SSI)" },
            ],
            required: false,
            isCustomField: true,
          }
        }
      },      
    }
  };

// Well Life Clinic deferred clinician assignment configuration
//
// Same patient metadata steps as the full WLC config (address, gender, DOB,
// Semble reference, contract type, patient type) but WITHOUT the clinician
// assignment steps (steps 2 and 3 in the full config). Clinicians are
// assigned after patient creation via the Patient Overview:
//   - AssignCliniciansDialog (Lead + optional MDT supporting)
//   - "Assign Clinician" buttons on AssessmentModuleCard
//   - "Assign clinician" button on the dashboard PatientTable
//
// This matches The Owl Centre / SLaM deferred-assignment pattern. The backend
// setupNewPatient already accepts an empty assignedClinicians map.
const wellLifeDeferredConfig = {
  steps: {
    '1': JSON.parse(JSON.stringify(wellLifeFullConfig.steps['1'])),
    '2': JSON.parse(JSON.stringify(wellLifeFullConfig.steps['4'])),
    '3': JSON.parse(JSON.stringify(wellLifeFullConfig.steps['5'])),
    '4': JSON.parse(JSON.stringify(wellLifeFullConfig.steps['6'])),
    '5': JSON.parse(JSON.stringify(wellLifeFullConfig.steps['7'])),
    '6': JSON.parse(JSON.stringify(wellLifeFullConfig.steps['8'])),
    '7': JSON.parse(JSON.stringify(wellLifeFullConfig.steps['9'])),
  }
};

// ADHD Clinical UK patient setup.
//
// Same deferred pattern as Well Life Clinic: the patient is created first,
// then a lead clinician is assigned from the Patient Overview. That
// assignment puts the lead on the Clinical Interview, the Semi-Structured
// Interview, the Diagnostic Decision and the Post-Assessment Discussion.
// A supporting clinician is added later, on the Diagnostic Decision card
// only, for the MDT Review.
//
// Two WLC steps are not copied:
//   - Contract type. WLC offers NHS contracts (SABP, RTC, Kent). This
//     clinic is private and does not categorise patients that way.
//   - The reference field is a plain "Patient Reference Number", not a
//     Semble reference. This clinic does not use Semble.
const adhdClinicalUkDeferredConfig = (() => {
  const config = JSON.parse(JSON.stringify(wellLifeDeferredConfig));
  const keptSteps = {};

  Object.keys(config.steps)
    .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
    .forEach((stepKey) => {
      const step = config.steps[stepKey];
      const fields = Object.values(step.fields || {});
      if (fields.some((field) => field.varName === 'assessmentType')) {
        return;
      }
      const referenceField = fields.find((field) => field.varName === 'referenceNumber');
      if (referenceField) {
        step.title = 'Reference Number';
        referenceField.displayText = 'Patient Reference Number';
        referenceField.placeholder = 'Enter Patient Reference Number';
      }
      keptSteps[stepKey] = step;
    });

  const renumbered = {};
  Object.keys(keptSteps)
    .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
    .forEach((oldKey, index) => {
      renumbered[String(index + 1)] = keptSteps[oldKey];
    });
  config.steps = renumbered;
  return config;
})();


  // Psychological Consultations specific configuration
const psychologicalConsultationsConfig = {
  steps: {
      // Steps 1 and 2 are the same as default
      '1': JSON.parse(JSON.stringify(defaultConfig.steps['1'])),
      '2': JSON.parse(JSON.stringify(defaultConfig.steps['2'])),      
      // Step 3 with the modified field
      '3': {
        ...JSON.parse(JSON.stringify(defaultConfig.steps['3'])),
        title: "Assign Clinicians to Assessment Stages",
        fields: {
          ...JSON.parse(JSON.stringify(defaultConfig.steps['3'].fields)),
          // Override the specific field directly
          '3': {
              varName: "clinicianDD",
              displayText: "Diagnostic Decision",
              inputType: "selectOneButtons", 
              required: true,
          },
          '4': {
            varName: "clinicianPAD",
            displayText: "Post-Assessment Discussion",
            inputType: "selectOneButtons",          
            required: true,
          }
        }
      },
      '4': JSON.parse(JSON.stringify(defaultConfig.steps['4'])),       
  }
};


// The Owl Centre specific configuration
//
// Key difference from other orgs: The Owl Centre does NOT assign clinicians during
// patient setup. They onboard patients first, then retroactively assign clinicians
// via the Patient Overview page. This means:
// - Steps 2 (Assign Users) and 3 (Assign to Assessment Stages) are omitted entirely
// - Until clinicians are assigned, only Org. Admin and Support users can see the patient
//   (Clinician-type users require assignment to at least one clinical stage for access)
// - Firestore rules enforce this automatically via clinicianHasPatientAccess() checks
const owlCentreConfig = {
  steps: {
    '1': {
      title: "Patient Information",
      fields: {
        '1': {
          varName: "title",
          displayText: "Title",
          inputType: "selectOneDropdown",
          options: [
            { value: "Mr.", label: "Mr." },
            { value: "Mrs.", label: "Mrs." },
            { value: "Ms.", label: "Ms." },
            { value: "Miss", label: "Miss" },
            { value: "Dr.", label: "Dr." },
            { value: "Other", label: "Other / Prefer not to say" },
          ],
          isCustomField: true,
          required: false,
        },
        '2': {
          varName: "firstName",
          displayText: "First Name",
          inputType: "freeText",
          placeholder: "Enter first name",
          required: true,
        },
        '3': {
          varName: "lastName",
          displayText: "Last Name",
          inputType: "freeText",
          placeholder: "Enter last name",
          required: true,
        },
        '4': {
          varName: "email",
          displayText: "Email Address",
          inputType: "freeText",
          placeholder: "Enter email address",
          required: true,
        },
      }
    },
    '2': {
      title: "Patient's Date of Birth",
      fields: {
        '1': {
          varName: "dateOfBirth",
          displayText: "Date of Birth",
          inputType: "date",
          required: true,
          isCustomField: true,
        },
      }
    },
    '3': {
      title: "Patient's Home Address",
      fields: {
        '1': {
          varName: "streetAddress",
          displayText: "Street Address",
          inputType: "freeText",
          placeholder: "Enter their street address",
          required: true,
          isCustomField: true,
        },
        '2': {
          varName: "city",
          displayText: "City",
          inputType: "freeText",
          placeholder: "Enter their city",
          required: true,
          isCustomField: true,
        },
        '3': {
          varName: "postcode",
          displayText: "Postcode",
          inputType: "freeText",
          placeholder: "Enter their postcode",
          required: true,
          isCustomField: true,
        },
      }
    },
    '4': {
      title: "Patient's GP Details",
      // At least one of GP Name or GP Surgery must be provided so the report
      // can identify the referring GP. GP Address is optional.
      description: "At least one of GP Name or GP Surgery / Practice is required.",
      fields: {
        '1': {
          varName: "gpName",
          displayText: "GP Name",
          inputType: "freeText",
          placeholder: "Enter GP name",
          // requiredOneOf: at least one of gpName / gpSurgery must be filled.
          // GP Address is always optional.
          requiredOneOf: 'gpDetails',
          isCustomField: true,
        },
        '2': {
          varName: "gpSurgery",
          displayText: "GP Surgery / Practice",
          inputType: "freeText",
          placeholder: "Enter GP surgery or practice name",
          requiredOneOf: 'gpDetails',
          isCustomField: true,
        },
        '3': {
          varName: "gpAddress",
          displayText: "GP Address",
          inputType: "freeText",
          placeholder: "Enter GP address",
          required: false,
          isCustomField: true,
        },
      }
    },
    '5': {
      title: "NHS Number",
      fields: {
        '1': {
          varName: "nhsNumber",
          displayText: "NHS Number",
          inputType: "freeText",
          placeholder: "Enter NHS Number",
          required: true,
          isCustomField: true,
        }
      }
    },
    '6': {
      title: "NEST Reference Number",
      fields: {
        '1': {
          varName: "referenceNumber",
          displayText: "NEST Reference Number",
          inputType: "freeText",
          placeholder: "Enter NEST Reference Number",
          required: true,
          isCustomField: true,
        }
      }
    },
    '7': {
      // TOC/WLC terminology: "Contract Type" is the client-facing label for what the backend
      // stores as assessmentType. The varName remains unchanged so all downstream logic,
      // filters, and Firestore documents continue to work without migration.
      title: "Contract Type",
      fields: {
        '1': {
          varName: "assessmentType",
          displayText: "Contract Type",
          inputType: "selectOneDropdown",
          // Values must exactly match the keys in python-functions/functions/toc_report/contract_config.py
          // so that the TOC report template conditional engine can resolve the correct marker key.
          // Sourced from src/constants/assessmentTypesByOrg.js to stay aligned with
          // dashboard filters and provider analytics buckets.
          options: owlCentreContractTypeOptions(),
          required: true,
          isCustomField: true,
        },
        '2': {
          varName: "subContractType",
          displayText: "Subcontract Type",
          inputType: "selectOneDropdown",
          options: subContractTypeOptions(),
          required: true,
          isCustomField: true,
          // Declarative dependency: this field is only shown and validated when
          // the assessmentType is a contract that collects a subcontract.
          // The form component renders it greyed-out when the condition is not
          // met, and the validation helper skips it entirely.
          // Pathway gate: Adult Autism keeps this field as written (National
          // RTC ICB list, plus Hampshire's two sub-pathways). TOC and Demo
          // Org Adult ADHD keep it too, but getConfigPatientSetup narrows it
          // to National RTC and this same ICB list. Lancaster Adult ADHD,
          // and every other non-autism module, has the field removed.
          // TOC CYP ADHD does not use this shared adult config — it defines
          // its own National RTC ICB field on the CYP setup config.
          enabledWhen: {
            field: "assessmentType",
            oneOf: ["National RTC", "Hampshire & Isle of Wight Integrated Care Board"],
          },
          // Dynamic options: when the parent contract changes, the form swaps
          // the dropdown options to the set appropriate for that contract.
          // Falls back to `options` when no mapping matches.
          optionsByParent: SUBCONTRACT_OPTIONS_BY_CONTRACT,
        }
      }
    },
    '8': {
      title: "Patient Type",
      fields: {
        '1': {
          varName: "demoOrTest",
          displayText: "Patient Type",
          inputType: "selectOneDropdown",
          options: [
            { value: "Blank Patient", label: "Blank Patient" },

            { value: "Demo 1 (Male)", label: "Demo 1 (Male)" },
            { value: "Demo 2 (Female)", label: "Demo 2 (Female)" },

            { value: "Training Scenario 1 (Jane Smith)", label: "Training Scenario 1 (Jane Smith)" },
            { value: "Training Scenario 2 (John Smith)", label: "Training Scenario 2 (John Smith)" },
            { value: "Training Scenario 3 (Jane Doe)", label: "Training Scenario 3 (Jane Doe)" },
            { value: "Training Scenario 4 (John Doe)", label: "Training Scenario 4 (John Doe)" },
            { value: "Training Scenario 5 (John Smith - No SSI)", label: "Training Scenario 5 (John Smith - No SSI)" },
          ],
          required: false,
          isCustomField: true,
        }
      }
    }
  }
};


// CYP ADHD pathway config for Well Life Clinic (full version, retained for
// reference -- previously used when WLC assigned clinicians at CYP setup).
// The active config is wellLifeCypAdhdDeferredConfig below.
//
// Children don't have their own email or title — the guardian's contact details
// are collected in a separate step and sent to the backend as a nested object.
// The child's date of birth and gender are collected for personalisation.
// Deliberately NOT collected at setup (product decision, 21 Aug): the child's
// pronouns and the guardian's relationship to the child — the clinic won't
// reliably know these at referral, so both are asked on the parent's basic
// information form instead (setup data prefills it, the parent confirms).

// Dev/staging CYP demo presets. Adult ADHD splits "Demo 1 (Male)" and
// "Demo 2 (Female)"; CYP needs the same split, and also an age split,
// because the interview hides the "before age 12" question under 13 and
// the puberty questions only make sense for some of these children.
//
// The backend (functions/cyp_adhd_demo_prefill.py) pins date of birth,
// gender and pronouns from the label. Keep the four values identical there.
export const CYP_DEMO_PRESET_GENDER = {
  "Demo Patient (Under 12 Male)": "Male",
  "Demo Patient (Under 12 Female)": "Female",
  "Demo Patient (Over 12 Male)": "Male",
  "Demo Patient (Over 12 Female)": "Female",
};

// Shown under Patient Type. Names what each option will do, because the
// date of birth, gender and sex assigned at birth typed earlier in the form
// are replaced.
export const CYP_DEMO_PATIENT_TYPE_HINT =
  "Each demo sets the child's age, gender, sex assigned at birth and pronouns. Under 12 is 9 years old, at primary school, and the puberty questions stay closed. Over 12 is 15 years old, at secondary school. Male uses he/him and the periods questions are not asked. Female uses she/her. The over-12 female demo is the one where periods have started. You can still auto-create a school informant for any of these. The parent or carer and the school are given different answers.";

// The child's sex assigned at birth, asked once at setup and shared by every
// CYP config so the option list cannot drift between organisations. Optional:
// the clinic often will not know it at referral, and a blank means "not
// known". The parent or carer confirms or corrects the value on their first
// form (About you and consent), and the backend copies their answer onto the
// patient record. The value drives the "periods gate": the periods questions,
// the Clinical Interview Puberty panel and the Puberty paragraph are hidden
// only when this is explicitly Male or Intersex (see
// src/utils/conditionChecks.js, cypPeriodsContentApplies). The option list
// is the Adult ADHD list minus "Prefer not to say", which only makes sense
// when the person answering is the one being asked about.
export const CYP_SEX_ASSIGNED_AT_BIRTH_FIELD = {
  varName: "sexAssignedAtBirth",
  displayText: "Sex assigned at birth",
  description: "Optional. Leave blank if not known; the parent or carer will be asked to confirm it.",
  inputType: "selectOneDropdown",
  options: [
    { value: "Female", label: "Female" },
    { value: "Male", label: "Male" },
    { value: "Intersex", label: "Intersex" },
  ],
  required: false,
  isCustomField: true,
};

export const CYP_DEMO_PATIENT_OPTIONS = [
  { value: "Blank Patient", label: "Blank Patient" },
  { value: "Demo Patient (Under 12 Male)", label: "Demo Patient (Under 12 Male)" },
  { value: "Demo Patient (Under 12 Female)", label: "Demo Patient (Under 12 Female)" },
  { value: "Demo Patient (Over 12 Male)", label: "Demo Patient (Over 12 Male)" },
  { value: "Demo Patient (Over 12 Female)", label: "Demo Patient (Over 12 Female)" },
];

/**
 * The Gender dropdown value a CYP demo preset stands for.
 *
 * Gender is asked before Patient Type. A clinician can set Female and then
 * pick a male demo, and the reports used to mix the two. Choosing a preset
 * fills Gender with the sex in its name, so the form shows the child the
 * answers will describe. Blank Patient, and every adult demo type, return
 * null and leave Gender alone.
 */
export function genderSelectionForCypDemoPreset(presetValue) {
  const gender = CYP_DEMO_PRESET_GENDER[presetValue];
  if (!gender) return null;
  return { value: gender, label: gender };
}

/**
 * Every identity field a CYP demo preset pins, keyed by the setup varName,
 * each as the `{ value, label }` option the dropdowns store.
 *
 * The four demo presets name a sex ("Under 12 Female"), and both the Gender
 * and the Sex assigned at birth dropdowns are filled from it so the form
 * shows the child the demo answers describe. The backend
 * (functions/cyp_adhd_demo_prefill.py) pins the same values again, so the
 * two must agree. Returns null for Blank Patient and every adult demo type,
 * which leave both dropdowns alone.
 *
 * @param {string|null|undefined} presetValue - The selected Patient Type value
 * @returns {{genderIdentity: {value: string, label: string}, sexAssignedAtBirth: {value: string, label: string}}|null}
 */
export function demoIdentityForCypPreset(presetValue) {
  const pinned = genderSelectionForCypDemoPreset(presetValue);
  if (!pinned) return null;
  return {
    genderIdentity: pinned,
    sexAssignedAtBirth: { ...pinned },
  };
}

const wellLifeCypAdhdConfig = {
  steps: {
    '1': {
      title: "Child's Information",
      fields: {
        '1': {
          varName: "firstName",
          displayText: "Child's First Name",
          inputType: "freeText",
          placeholder: "Enter the child's first name",
          required: true,
        },
        '2': {
          varName: "lastName",
          displayText: "Child's Last Name",
          inputType: "freeText",
          placeholder: "Enter the child's last name",
          required: true,
        },
        '3': {
          varName: "dateOfBirth",
          displayText: "Date of Birth",
          inputType: "date",
          // Required at setup. The SSI uses the date of birth to decide which
          // age questions to ask, and the backend rejects a CYP record with no
          // date of birth (setup_validation.py, dobRequired). The year dropdown
          // offers ages 5-18. The picker lists whole birth years, so with a
          // ceiling of 17 the oldest date a clinician could pick was 1 January
          // of (this year - 17) — 17 years and 9 months old by October, which
          // blocked children who were already 18 or nearly 18. 19+ belongs on
          // Adult ADHD. A child who turns 19 mid-pathway carries on in CYP.
          required: true,
          isCustomField: true,
          minAgeYears: 5,
          maxAgeYears: 18,
        },
        '4': {
          varName: "genderIdentity",
          displayText: "Gender",
          inputType: "selectOneDropdown",
          options: [
            { value: "Male", label: "Male" },
            { value: "Female", label: "Female" },
            { value: "Non-binary", label: "Non-binary" },
            { value: "Unspecified", label: "Unspecified" },
          ],
          required: false,
          isCustomField: true,
        },
        '5': { ...CYP_SEX_ASSIGNED_AT_BIRTH_FIELD },
      },
    },
    '2': {
      title: "Parent / Carer Information",
      fields: {
        '1': {
          varName: "guardianFirstName",
          displayText: "First Name",
          inputType: "freeText",
          placeholder: "Enter the parent or carer's first name",
          required: true,
          isGuardianField: true,
        },
        '2': {
          varName: "guardianLastName",
          displayText: "Last Name",
          inputType: "freeText",
          placeholder: "Enter the parent or carer's last name",
          // Required so the parent record, welcome email, and clinician
          // lists have a full name. A first name alone is ambiguous when
          // two parents share one.
          required: true,
          isGuardianField: true,
        },
        '3': {
          varName: "guardianEmail",
          displayText: "Email Address",
          inputType: "freeText",
          placeholder: "Enter the parent or carer's email address",
          required: true,
          isGuardianField: true,
        },
      },
    },
    '3': {
      title: "Assign Users to Patient",
      fields: {
        '1': {
          varName: "leadClinician",
          displayText: "Lead Clinician",
          inputType: "selectOneDropdown",
          placeholder: "Select the lead clinician",
          required: true,
        },
        '2': {
          varName: "supportClinicians",
          displayText: "Additional Clinician(s)",
          inputType: "selectMultipleDropdown",
          placeholder: "Select additional clinician(s)",
          required: false,
        },
      },
    },
    '4': {
      ...JSON.parse(JSON.stringify(defaultConfig.steps['3'])),
      title: "Assign Clinicians to Assessment Stages",
      fields: {
        ...JSON.parse(JSON.stringify(defaultConfig.steps['3'].fields)),
        '3': {
          varName: "clinicianDD",
          displayText: "Diagnosis Decision (MDT Review)",
          inputType: "selectMultipleButtons",
          required: true,
          minSelections: 1,
        },
        '4': {
          varName: "clinicianPAD",
          displayText: "Post-Assessment Discussion",
          inputType: "selectOneButtons",
          required: true,
        },
      },
    },
    '5': {
      title: "Reference Number",
      fields: {
        '1': {
          varName: "referenceNumber",
          displayText: "Semble Reference Number",
          inputType: "freeText",
          placeholder: "Enter Semble Reference Number",
          required: true,
          isCustomField: true,
        },
      },
    },
    '6': {
      title: "Contract Type",
      fields: {
        '1': {
          varName: "assessmentType",
          displayText: "Contract Type",
          inputType: "selectOneDropdown",
          // CYP ADHD referrals at WLC are private-only (no NHS-funded CYP
          // contracts). Uses the CYP-specific list, not the adult list.
          options: wellLifeCypContractTypeOptions(),
          required: true,
          isCustomField: true,
        },
      },
    },
    '7': {
      title: "Patient Type",
      fields: {
        '1': {
          varName: "demoOrTest",
          displayText: "Patient Type",
          inputType: "selectOneDropdown",
          options: CYP_DEMO_PATIENT_OPTIONS,
          description: CYP_DEMO_PATIENT_TYPE_HINT,
          required: false,
          isCustomField: true,
        },
      },
    },
  },
};

// CYP ADHD deferred clinician assignment configuration
//
// Same child / guardian / metadata steps as wellLifeCypAdhdConfig but WITHOUT
// the clinician assignment steps (steps 3 and 4 in the full CYP config).
// Clinicians are assigned after creation via the CYP Patient Overview, using
// the same AssignCliniciansDialog as adult ADHD.
const wellLifeCypAdhdDeferredConfig = {
  steps: {
    '1': JSON.parse(JSON.stringify(wellLifeCypAdhdConfig.steps['1'])),
    '2': JSON.parse(JSON.stringify(wellLifeCypAdhdConfig.steps['2'])),
    '3': JSON.parse(JSON.stringify(wellLifeCypAdhdConfig.steps['5'])),
    '4': JSON.parse(JSON.stringify(wellLifeCypAdhdConfig.steps['6'])),
    '5': JSON.parse(JSON.stringify(wellLifeCypAdhdConfig.steps['7'])),
  }
};

// School Representative step — retained for future re-enablement.
//
// TOC originally intended to set the school representative at patient setup
// (from the referral pack), bypassing the parent nomination gate. TOC have
// since confirmed (Oct 2026) that the parent/carer will always nominate the
// school rep, matching WLC's flow. The step is kept here as a standalone
// const so the code is ready if the decision is ever reversed; re-add it to
// owlCentreCypAdhdDeferredConfig's steps (and renumber the ones after it).
const _owlCentreCypSchoolRepStep = {
  title: "School Representative",
  // TOC usually hold the school contact from the referral pack. Providing
  // it here creates the school representative's account immediately and
  // spares the parent the nomination gate; left blank, the parent is
  // asked to nominate (and, for a child in school, blocked until they
  // do — cypAdhdFlow.schoolRepNomination). All-or-nothing: if any field
  // is filled, the backend requires name, email, role and school.
  description: "Optional. If you already have the school contact, enter their details to invite them now — otherwise leave blank and the parent or carer will be asked to nominate them.",
  fields: {
    '1': {
      varName: "schoolRepFirstName",
      displayText: "First Name",
      inputType: "freeText",
      placeholder: "Enter the school representative's first name",
      required: false,
    },
    '2': {
      varName: "schoolRepLastName",
      displayText: "Last Name",
      inputType: "freeText",
      placeholder: "Enter the school representative's last name",
      required: false,
    },
    '3': {
      varName: "schoolRepEmail",
      displayText: "Email Address",
      inputType: "freeText",
      placeholder: "Enter the school representative's email address",
      required: false,
    },
    '4': {
      varName: "schoolRepRole",
      displayText: "Their Role at the School",
      inputType: "freeText",
      placeholder: "For example SENCO or class teacher",
      required: false,
    },
    '5': {
      varName: "schoolRepSchoolName",
      displayText: "School or College",
      inputType: "freeText",
      placeholder: "Name of the school or college",
      required: false,
    },
  },
};

// CYP ADHD setup config for The Owl Centre (deferred clinician assignment,
// like all TOC setup). Built from the WLC CYP child/guardian steps plus the
// patient identifiers TOC's adult setup collects (address, GP, NHS number,
// reference, TOC contract types) — see TOC_CYP_ADHD_HANDOVER.md A3.1/B3.1.
//
// Differences from the WLC CYP config, and why (TOC requirements, Sept 2026):
// - Age 6 to 17 measured at the REFERRAL date, so setup captures a Referral
//   Date and the backend validates the child's age against it
//   (constants/cyp_adhd/setup_validation.py — keep the two in sync). The
//   date-of-birth year dropdown offers birth years for ages 6 through 17.
// - Date of birth is required (the age rule cannot be applied without it);
//   NHS number is collected but optional.
// - Contract Type is restricted to National RTC only for the initial CYP
//   rollout. Additional contracts will follow once TOC confirm them. The
//   backend still accepts any TOC_CONTRACT_KEYS value, so widening this
//   list later is a frontend-only change.
// - Subcontract Type is collected only when Contract Type is National RTC,
//   and the options are the same commissioning ICB list Adult Autism uses
//   (SUBCONTRACT_TYPES). Hampshire & Isle of Wight's adult-autism
//   sub-pathways are not offered here. Other contracts do not ask.
// - School representative is NOT collected at setup (Oct 2026 confirmation):
//   the parent/carer nominates the school rep, matching WLC. The step is
//   retained as _owlCentreCypSchoolRepStep above if it needs to be restored.
const owlCentreCypAdhdDeferredConfig = {
  steps: {
    '1': {
      title: "Child's Information",
      fields: {
        '1': {
          varName: "firstName",
          displayText: "Child's First Name",
          inputType: "freeText",
          placeholder: "Enter the child's first name",
          required: true,
        },
        '2': {
          varName: "lastName",
          displayText: "Child's Last Name",
          inputType: "freeText",
          placeholder: "Enter the child's last name",
          required: true,
        },
        '3': {
          varName: "dateOfBirth",
          displayText: "Date of Birth",
          inputType: "date",
          required: true,
          isCustomField: true,
          minAgeYears: 6,
          maxAgeYears: 17,
        },
        '4': {
          varName: "genderIdentity",
          displayText: "Gender",
          inputType: "selectOneDropdown",
          options: [
            { value: "Male", label: "Male" },
            { value: "Female", label: "Female" },
            { value: "Non-binary", label: "Non-binary" },
            { value: "Unspecified", label: "Unspecified" },
          ],
          required: false,
          isCustomField: true,
        },
        '5': { ...CYP_SEX_ASSIGNED_AT_BIRTH_FIELD },
      },
    },
    '2': {
      title: "Child's Home Address",
      fields: {
        '1': {
          varName: "streetAddress",
          displayText: "Street Address",
          inputType: "freeText",
          placeholder: "Enter their street address",
          required: true,
          isCustomField: true,
        },
        '2': {
          varName: "city",
          displayText: "City",
          inputType: "freeText",
          placeholder: "Enter their city",
          required: true,
          isCustomField: true,
        },
        '3': {
          varName: "postcode",
          displayText: "Postcode",
          inputType: "freeText",
          placeholder: "Enter their postcode",
          required: true,
          isCustomField: true,
        },
      },
    },
    '3': {
      title: "Child's GP Details",
      description: "At least one of GP Name or GP Surgery / Practice is required.",
      fields: {
        '1': {
          varName: "gpName",
          displayText: "GP Name",
          inputType: "freeText",
          placeholder: "Enter GP name",
          requiredOneOf: 'gpDetails',
          isCustomField: true,
        },
        '2': {
          varName: "gpSurgery",
          displayText: "GP Surgery / Practice",
          inputType: "freeText",
          placeholder: "Enter GP surgery or practice name",
          requiredOneOf: 'gpDetails',
          isCustomField: true,
        },
        '3': {
          varName: "gpAddress",
          displayText: "GP Address",
          inputType: "freeText",
          placeholder: "Enter GP address",
          required: false,
          isCustomField: true,
        },
      },
    },
    '4': {
      title: "NHS Number",
      fields: {
        '1': {
          varName: "nhsNumber",
          displayText: "NHS Number",
          inputType: "freeText",
          placeholder: "Enter NHS Number",
          // Optional per TOC (Sept 2026 requirements): almost always
          // available, but setup must not block when it is not.
          required: false,
          isCustomField: true,
        },
      },
    },
    '5': {
      title: "Parent / Carer Information",
      fields: {
        '1': {
          varName: "guardianFirstName",
          displayText: "First Name",
          inputType: "freeText",
          placeholder: "Enter the parent or carer's first name",
          required: true,
          isGuardianField: true,
        },
        '2': {
          varName: "guardianLastName",
          displayText: "Last Name",
          inputType: "freeText",
          placeholder: "Enter the parent or carer's last name",
          // Same rule as Well Life Clinic: the parent record needs a surname.
          required: true,
          isGuardianField: true,
        },
        '3': {
          varName: "guardianEmail",
          displayText: "Email Address",
          inputType: "freeText",
          placeholder: "Enter the parent or carer's email address",
          required: true,
          isGuardianField: true,
        },
      },
    },
    // School representative step removed (Oct 2026): TOC confirmed the
    // parent/carer will always nominate, matching WLC. The step definition is
    // retained as _owlCentreCypSchoolRepStep above for future re-enablement.
    '6': {
      title: "NEST Reference Number",
      fields: {
        '1': {
          varName: "referenceNumber",
          displayText: "NEST Reference Number",
          inputType: "freeText",
          placeholder: "Enter NEST Reference Number",
          required: true,
          isCustomField: true,
        },
      },
    },
    '7': {
      title: "Referral Date",
      description: "The date the referral was received. The child must be aged 6 to 17 at this date.",
      fields: {
        '1': {
          varName: "referralDate",
          displayText: "Referral Date",
          inputType: "date",
          required: true,
          isCustomField: true,
          // TOC measure the 6-17 age rule at the referral date, so it is
          // captured at setup and the backend validates the age against it
          // (constants/cyp_adhd/setup_validation.py). The year dropdown
          // offers the current year and the two before it.
          minAgeYears: 0,
          maxAgeYears: 2,
        },
      },
    },
    '8': {
      title: "Contract Type",
      fields: {
        '1': {
          varName: "assessmentType",
          displayText: "Contract Type",
          inputType: "selectOneDropdown",
          // National RTC only for the initial CYP rollout. When more
          // contracts are enabled, replace with the full TOC list
          // (owlCentreContractTypeOptions()) and update the tests below.
          options: [
            { value: "National RTC", label: "National RTC" },
          ],
          required: true,
          isCustomField: true,
        },
        // Shown only for National RTC. The dropdown is the same ICB list
        // Adult Autism and TOC Adult ADHD use for that contract, so a CYP
        // referral and an adult referral under National RTC record the
        // commissioning board in the same words. Required once the field is
        // on screen: a National RTC patient with no ICB (and not explicitly
        // N/A) cannot be told apart from one the clinician forgot to fill in.
        '2': {
          varName: "subContractType",
          displayText: "Subcontract Type",
          inputType: "selectOneDropdown",
          options: subContractTypeOptions(),
          required: true,
          isCustomField: true,
          enabledWhen: {
            field: "assessmentType",
            oneOf: ["National RTC"],
          },
          optionsByParent: {
            "National RTC": subContractTypeOptions(),
          },
        },
      },
    },
    '9': {
      title: "Patient Type",
      fields: {
        '1': {
          varName: "demoOrTest",
          displayText: "Patient Type",
          inputType: "selectOneDropdown",
          // Same demo presets as WLC CYP (the whole step is stripped in
          // production). The backend pins age, gender and pronouns. Both
          // pinned ages (9 and 15) sit inside TOC's 6-17 range.
          options: CYP_DEMO_PATIENT_OPTIONS,
          description: CYP_DEMO_PATIENT_TYPE_HINT,
          required: false,
          isCustomField: true,
        },
      },
    },
  },
};

// CYP ADHD setup configs by organisation. The CYP pathway replaces the org's
// standard setup config entirely (children have no email or auth account and
// the guardian is created in the same step), so each CYP org gets a dedicated
// config here rather than overlaying overrides on the adult one. Orgs without
// an entry fall back to the WLC config — acceptable for demos, but any org
// taking real CYP referrals needs its own entry (contract types are validated
// against the org's own list at creation).
const cypAdhdSetupConfigByOrg = {
  default: wellLifeCypAdhdDeferredConfig,
  "The Owl Centre": owlCentreCypAdhdDeferredConfig,
};

// Export the configurations for different organizations
export const setupConfig = {
    // Testing / Demos
    default: defaultConfig,
    "ThinkDivergent": TDServiceConfig,   
    "ThinkDivergent Admin": defaultConfig,
    // Customers
    "Phoenix Mental Health Services": phoenixConfig,    
    "Well Life Clinic": wellLifeDeferredConfig,
    "MDT Org": wellLifeDeferredConfig,
    // Private adult ADHD clinic. Deferred clinician assignment like WLC,
    // without the Semble reference label or the NHS contract-type step.
    "ADHD Clinical UK": adhdClinicalUkDeferredConfig,
    // Same deferred-clinician / Contract Type setup flow as The Owl Centre,
    // but with the generic "Patient Reference Number" label (NEST is
    // TOC-specific branding). Deep-cloned so the label override does not
    // mutate owlCentreConfig.
    "Lancaster Medical Practice": (() => {
      const config = JSON.parse(JSON.stringify(owlCentreConfig));
      const refStep = Object.values(config.steps).find(s => s.fields?.['1']?.varName === 'referenceNumber');
      if (refStep) {
        refStep.title = "Reference Number";
        refStep.fields['1'].displayText = "Patient Reference Number";
        refStep.fields['1'].placeholder = "Enter Patient Reference Number";
      }
      return config;
    })(),
    "ADHD and Autism Associates": defaultConfig,
    "The Spectrum Mind Clinic": defaultConfig,
    "SLaM": slamDeferredConfig,
    "3 Borough Adult ADHD and Autism Service": slamDeferredConfig,
    // Private org on the SLaM clinical workflow: deferred assignment without
    // the NHS identifier steps.
    "Urban ADHD": urbanAdhdDeferredConfig,
    "Psychological Consultations": psychologicalConsultationsConfig,
    "The Owl Centre": owlCentreConfig,
    "Demo Org": (() => {
      const config = JSON.parse(JSON.stringify(owlCentreConfig));
      const refStep = Object.values(config.steps).find(s => s.fields?.['1']?.varName === 'referenceNumber');
      if (refStep) {
        refStep.title = "Reference Number";
        refStep.fields['1'].displayText = "Patient Reference Number";
        refStep.fields['1'].placeholder = "Enter Patient Reference Number";
      }
      return config;
    })(),
  };

// ─── Per-pathway overrides for contract type options ──────────────────────
// Some orgs restrict contract types to a subset depending on the assessment
// pathway. These overrides are applied by getConfigPatientSetup when a module
// is specified. Structure: { orgName: { module: [options] } }
const CONTRACT_TYPE_OVERRIDES = {
  "The Owl Centre": {
    // Adult Autism rollout: National RTC and Hampshire IOW (both with
    // subcontracts) plus the other enabled contracts.
    // Values must match TOC_CONTRACT_KEYS in toc_report/contract_config.py
    // (and ASSESSMENT_TYPES_BY_ORG when the type is also used for ADHD).
    adultAutism: [
      { value: "National RTC", label: "National RTC" },
      { value: "Private", label: "Private" },
      { value: "HR100", label: "HR100" },
      { value: "Lexxic Ltd", label: "Lexxic Ltd" },
      { value: "Norfolk RTC", label: "Norfolk RTC" },
      { value: "Essex Integrated Care Board", label: "Essex Integrated Care Board" },
      { value: "Humber Teaching NHS Foundation Trust", label: "Humber Teaching NHS Foundation Trust" },
      { value: "Hampshire & Isle of Wight Integrated Care Board", label: "Hampshire & Isle of Wight Integrated Care Board" },
      { value: "Kent & Medway Integrated Care Board", label: "Kent & Medway Integrated Care Board" },
    ],
  },
  "Demo Org": {
    // Demo Org uses a smaller contract list than production TOC.
    adultAutism: [
      { value: "National RTC", label: "National RTC" },
      { value: "Private", label: "Private" },
      { value: "Lexxic Ltd", label: "Lexxic Ltd" },
    ],
  },
  // LMP ADHD: National RTC and Private only. Autism stays National RTC only.
  "Lancaster Medical Practice": {
    adultAdhd: [
      { value: "National RTC", label: "National RTC" },
      { value: "Private", label: "Private" },
    ],
    adultAutism: [
      { value: "National RTC", label: "National RTC" },
    ],
  },
};

// ─── Per-pathway overrides for demo/patient-type options ──────────────────
// When an autism patient is being created, the demo patient type step should
// show simplified options (no gendered demos or training scenarios — just a
// single realistic demo patient). Applied by getConfigPatientSetup alongside
// contract type overrides.
const DEMO_OPTIONS_OVERRIDES = {
  adultAutism: [
    { value: "Blank Patient", label: "Blank Patient" },
    { value: "Demo Patient", label: "Demo Patient" },
    { value: "Training Scenario 1 (Lead Clinician)", label: "Training Scenario 1 (Lead Clinician)" },
    { value: "Training Scenario 2 (Observation Clinician)", label: "Training Scenario 2 (Observation Clinician)" },
  ],
};

/**
 * Remove the Subcontract Type field from a cloned adult setup config.
 *
 * Used for pathways that must not ask the question (Lancaster Adult ADHD,
 * and any other non-autism module that is not TOC Adult ADHD). TOC CYP
 * ADHD is not processed here — it has its own config, returned earlier,
 * which asks for the National RTC ICB list.
 */
function removeSubContractTypeField(config) {
  for (const step of Object.values(config?.steps || {})) {
    if (!step?.fields) continue;
    for (const fieldKey of Object.keys(step.fields)) {
      if (step.fields[fieldKey]?.varName === 'subContractType') {
        delete step.fields[fieldKey];
      }
    }
  }
  return config;
}

/**
 * Narrow a cloned setup config so Adult ADHD only asks for a subcontract
 * under National RTC, using the same ICB list as Adult Autism.
 *
 * The shared Owl config was written for Adult Autism, which also asks
 * under Hampshire & Isle of Wight. Those two options are autism
 * sub-pathways ("Hampshire IOW Adult Autism", "Portsmouth Adult Autism")
 * and Adult ADHD is not commissioned under Hampshire, so they must not
 * appear on an ADHD record. National RTC keeps the ICB names unchanged.
 *
 * Mutates the clone. Callers must not pass the shared original config,
 * or Adult Autism would lose its Hampshire options.
 */
function restrictSubContractTypeToNationalRtc(config) {
  for (const step of Object.values(config?.steps || {})) {
    if (!step?.fields) continue;
    for (const field of Object.values(step.fields)) {
      if (field?.varName !== 'subContractType') continue;
      const nationalRtcOptions =
        field.optionsByParent?.['National RTC'] || field.options;
      field.enabledWhen = {
        field: 'assessmentType',
        oneOf: ['National RTC'],
      };
      field.options = nationalRtcOptions;
      field.optionsByParent = {
        'National RTC': nationalRtcOptions,
      };
    }
  }
  return config;
}

/**
 * Returns the patient setup config for a given organisation, optionally
 * applying per-pathway overrides (e.g. restricting contract type options
 * when the selected assessment module limits what is available, or showing
 * pathway-specific demo patient options).
 *
 * @param {string} organizationName - The org name key
 * @param {string} [assessmentModule] - Optional pathway key (e.g. 'adultAutism')
 */
export const getConfigPatientSetup = (organizationName, assessmentModule) => {
    // CYP ADHD uses a dedicated config with guardian fields and no patient email.
    // This replaces the standard org config entirely rather than overlaying
    // overrides, and is resolved per organisation (WLC and TOC collect
    // different identifiers, contract types and age ranges at setup).
    if (assessmentModule === 'cypAdhd') {
        const cypConfig =
            cypAdhdSetupConfigByOrg[organizationName] || cypAdhdSetupConfigByOrg.default;
        return JSON.parse(JSON.stringify(cypConfig));
    }

    const baseConfig = setupConfig[organizationName] || setupConfig.default;
    if (!assessmentModule) return baseConfig;

    // The shared adult config includes subcontract for Adult Autism
    // (National RTC and Hampshire). TOC and Demo Org Adult ADHD keep the
    // field and narrow it to National RTC with the same ICB list. Every
    // other non-autism module has the field removed. CYP ADHD never gets
    // here — it returned its own config above.
    const collectNationalRtcSubcontract =
        assessmentModule === 'adultAdhd'
        && adultAdhdCollectsNationalRtcSubcontract(organizationName);
    const stripSubContractType =
        assessmentModule !== 'adultAutism' && !collectNationalRtcSubcontract;

    // Check if there are contract type overrides for this org + module combo
    const orgOverrides = CONTRACT_TYPE_OVERRIDES[organizationName];
    const hasContractOverride = orgOverrides && orgOverrides[assessmentModule];

    // Check if there are demo/patient-type overrides for this module
    const hasDemoOverride = !!DEMO_OPTIONS_OVERRIDES[assessmentModule];

    if (
        !hasContractOverride
        && !hasDemoOverride
        && !stripSubContractType
        && !collectNationalRtcSubcontract
    ) return baseConfig;

    // Deep-clone to avoid mutating the source config
    const config = JSON.parse(JSON.stringify(baseConfig));

    for (const stepKey of Object.keys(config.steps || {})) {
      const step = config.steps[stepKey];
      if (!step?.fields) continue;
      for (const fieldKey of Object.keys(step.fields)) {
        const field = step.fields[fieldKey];

        // Apply contract type override
        if (hasContractOverride && field.varName === 'assessmentType') {
          field.options = orgOverrides[assessmentModule];
        }

        // Apply demo patient type override
        if (hasDemoOverride && field.varName === 'demoOrTest') {
          field.options = DEMO_OPTIONS_OVERRIDES[assessmentModule];
        }
      }
    }

    if (stripSubContractType) {
      removeSubContractTypeField(config);
    }
    if (collectNationalRtcSubcontract) {
      restrictSubContractTypeToNationalRtc(config);
    }

    return config;
};

/**
 * Returns true if the given organisation's patient setup flow includes a mandatory
 * lead clinician assignment step. Orgs that defer clinician assignment to after
 * patient creation (e.g. The Owl Centre) will return false — meaning the
 * "Needs clinician assigned" quick-filter chip is relevant for those orgs.
 *
 * Detection works by scanning all steps in the org's config for a field with
 * varName "leadClinician" and required === true, so new orgs that follow the
 * standard pattern are handled automatically without hard-coding org names.
 */
export const orgRequiresClinicianAtSetup = (organisationName) => {
    const config = getConfigPatientSetup(organisationName);
    if (!config?.steps) return false;

    return Object.values(config.steps).some(step =>
        step.fields && Object.values(step.fields).some(
            field => field.varName === 'leadClinician' && field.required === true
        )
    );
};

/**
 * The two actual SLaM NHS trust organisations. Kept separate from
 * SLAM_ORG_NAMES below because some behaviour is tied to SLaM *as an NHS
 * service* rather than to the SLaM *clinical workflow shape*:
 *   - the on-screen self-harm crisis dialog in PatientFormTemplate carries
 *     SLaM-specific service names, phone numbers and the slam.nhs.uk/crisis
 *     link, so it must only ever be shown to SLaM / 3 Borough patients.
 * Mirrors the backend's narrow `_SLAM_SERVICE_USER_ORGS` set in
 * functions/notification/org_service_user_email_config.py, which gates the
 * matching crisis-support email in exactly the same way.
 */
const SLAM_NHS_ORG_NAMES = ['SLaM', '3 Borough Adult ADHD and Autism Service'];

/**
 * Canonical list of organisation names that use SLaM-style deferred, per-stage
 * clinician assignment (patients are created with no clinicians and assigned
 * afterwards via reassignClinicians). Kept in one place so that adding or
 * removing an org is a single-line change rather than a find-and-replace
 * across the codebase.
 *
 * Note this is an ORG-level gate for the assignment UX only. Whether a given
 * patient gets the legacy two-clinician SSI-first flow or the one-clinician
 * CI-first flow is decided per patient from the stamped workflow
 * (useWorkflowConfig().isSSIFirst), not from this list.
 *
 * This is a superset of SLAM_NHS_ORG_NAMES: Urban ADHD is a private provider
 * that adopted the SLaM two-clinician SSI-first clinical workflow, so it needs
 * the same assignment UX but none of the NHS-only content gated by isSlamNhsOrg.
 */
const SLAM_ORG_NAMES = [...SLAM_NHS_ORG_NAMES, 'Urban ADHD'];

/**
 * Returns true if the given organisation uses the SLaM-style deferred
 * clinician assignment UX (PatientOverview unassigned cards, PatientTable
 * "Assign Lead" / "Assign SSI" buttons, AssignCliniciansDialog SLaM mode).
 * This centralises the check that was previously hard-coded in multiple
 * places so that the set of org names is maintained in one list.
 *
 * Do NOT use this to gate NHS-specific copy or safety content — use
 * isSlamNhsOrg for that.
 */
export const isSlamOrg = (organisationName) =>
    SLAM_ORG_NAMES.includes(organisationName);

/**
 * Returns true only for the SLaM NHS trust organisations (SLaM, 3 Borough).
 * Use this for behaviour that embeds SLaM NHS service details — currently the
 * self-harm crisis support dialog shown to patients mid-questionnaire. Private
 * orgs on the SLaM workflow (e.g. Urban ADHD) deliberately return false here.
 */
export const isSlamNhsOrg = (organisationName) =>
    SLAM_NHS_ORG_NAMES.includes(organisationName);